import Vue from 'vue';
import VueRouter from 'vue-router';

import Index from '@/views/index.vue';
import NotFound from '@/components/view/404.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/:id?',
    name: 'index-id',
    component: Index,
    meta: {
      permission: true,
    },
  },
  {
    path: '*',
    name: '404',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
